// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import barChart01Icon from "@/assets/icons/bar-chart-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type BarChart01IconProps = Omit<IconProps, "name">;

export function BarChart01Icon(props: BarChart01IconProps): React.ReactNode {
  return <Icon name={barChart01Icon} {...props} />;
}
